import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LastSeenMessage,
  StopConnection,
} from "../../../services/signalRService/signalRService";
import { resetChatState } from "../../../services/store/slice/ChatSlice";
import { useNavigate } from "react-router-dom";
import { setIsLogOutModalOpen } from "../../../services/store/slice/NotificationSlice";
import { deleteIndexDB } from "../../../../utils/IndexedDBUtils";

export default function SignoutModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { device } = useSelector((state) => state.call);
  const getUserId = localStorage.getItem("user_id");
  const { isLogOutModalOpen } = useSelector((state) => state.notification);
  const userRoles = JSON.parse(localStorage.getItem("user_roles"));
  const userId_FromLocalStorage = localStorage.getItem("user_id");

  const handleLogoutRemember = async () => {
    // Get existing saved credentials from localStorage
    const savedCredentials =
      JSON.parse(localStorage.getItem("MaxChatCredentials")) || [];
    const savedUserName = localStorage.getItem("username");
    // Ensure savedCredentials is an array
    const usersArray = Array.isArray(savedCredentials)
      ? savedCredentials
      : [savedCredentials];

    localStorage.clear();

    // if (savedCredentials && savedUserName) {
    //   localStorage.setItem("MaxChatCredentials", savedCredentials);
    //   localStorage.setItem("username", savedUserName);
    // }
    // Re-save the MaxChatCredentials and username if available
    if (usersArray?.length > 0) {
      localStorage.setItem("MaxChatCredentials", JSON.stringify(usersArray));
    }
    if (savedUserName) {
      localStorage.setItem("username", savedUserName);
    }

    await LastSeenMessage(getUserId);
    // handleClose();
    dispatch(setIsLogOutModalOpen(false));
    // localStorage.clear();
    dispatch(resetChatState());
    await StopConnection();
    if (device) {
      device.removeAllListeners();
      // device.off("ready", handleReady);
      // device.off("error", handleError);
      // device.off("incoming", handleIncoming);
      // device.off("disconnect", handleDisconnect);
      device.destroy();
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ logout: true, id: userId_FromLocalStorage })
      );
    }
    await deleteIndexDB("MaxChats");
    navigate("/");
    window.location.reload();
  };
  const handleLogout = async () => {
    await LastSeenMessage(getUserId);
    // handleClose();
    dispatch(setIsLogOutModalOpen(false));

    // Get current logged-in username
    const loginUserName = localStorage.getItem("username");

    // Get and ensure saved credentials is an array
    const savedCredentials =
      JSON.parse(localStorage.getItem("MaxChatCredentials")) || [];
    const usersArray = Array.isArray(savedCredentials)
      ? savedCredentials
      : [savedCredentials];

    // Filter out the current user
    const updatedCredentials = usersArray?.filter(
      (item) => item?.userName !== loginUserName
    );

    // Clear localStorage and re-set filtered accounts
    localStorage.clear();
    if (updatedCredentials?.length > 0) {
      localStorage.setItem(
        "MaxChatCredentials",
        JSON.stringify(updatedCredentials)
      );
    }
    dispatch(resetChatState());
    await StopConnection();
    if (device) {
      device.removeAllListeners();
      // device.off("ready", handleReady);
      // device.off("error", handleError);
      // device.off("incoming", handleIncoming);
      // device.off("disconnect", handleDisconnect);
      device.destroy();
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ logout: true, id: userId_FromLocalStorage })
      );
    }
    await deleteIndexDB("MaxChats");
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      {/* for Log-Out UI */}
      <Modal
        open={isLogOutModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "1rem",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              maxWidth: "400px",
              margin: "0 auto",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              textAlign="center"
              fontWeight="bold"
              color="#333"
              mb="1rem"
            >
              Sign out
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{
                textAlign: "center",
                color: "#555",
                marginBottom: "1.5rem",
              }}
            >
              Remember account and application settings on this device?
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0.75rem",
              }}
            >
              <Button
                variant="contained"
                onClick={handleLogoutRemember}
                sx={{
                  // width: "100%",
                  backgroundColor: "#444",
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
              >
                Sign out and remember
              </Button>
              <Button
                variant="contained"
                onClick={handleLogout}
                sx={{
                  // width: "100%",
                  backgroundColor: "#444",
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
              >
                Sign out and Forget
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  dispatch(setIsLogOutModalOpen(false));
                }}
                sx={{
                  // width: "100%",
                  backgroundColor: "#444",
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
// Modal Styling
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "60%", lg: "30%", xl: "30%" },
  bgcolor: "background.paper",
  borderRadius: 2,
  p: 1,
};
